import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
interface Rule {
  title: string;
  enabled: boolean;
  when: string;
  then: string;
  priority: string;
  image?: string;
}

interface RuleSet {
  id: string;
  title: string;
  status: string;
  rules: Rule[];
  description?: string;
}

@Component({
  selector: 'app-src-rules',
  templateUrl: './src-rules.component.html',
  styleUrls: ['./src-rules.component.scss']
})
export class SrcRulesComponent implements OnInit {
  ruleSets: any[] = [];
  selectedRuleSetId = '';
  selectedRuleSet: any = null;
  ruleTypes = ['Usage', 'Health', 'Prescription'];
  selectedRuleType = 'Usage';
  planDefinitionRules: any[] = [];
  page = 1;
  pageSize = 3;
  ruleToEdit: Rule | null = null;
  ruleSetToEdit: RuleSet | null = null;
  showEditRuleModal = false;

  get pagedRules() {
    // Use planDefinitionRules for display, paginated
    const start = (this.page - 1) * this.pageSize;
    return this.planDefinitionRules.slice(start, start + this.pageSize);
  }
  get totalPages() {
    return Math.ceil(this.planDefinitionRules.length / this.pageSize);
  }
  showAddRuleSetFab = true;
  showAddRuleSetModal = false;
  showEditRuleSetModal = false;
  // ruleSetToEdit: any = null;
  availableItems: string[] = [];
  selectedItems: string[] = [];
  availableFilter = '';
  selectedFilter = '';
  get filteredAvailableItems() {
    return this.availableItems.filter(item =>
      item.toLowerCase().includes(this.availableFilter.toLowerCase()) &&
      !this.selectedItems.includes(item)
    );
  }
  get filteredSelectedItems() {
    return this.selectedItems.filter(item =>
      item.toLowerCase().includes(this.selectedFilter.toLowerCase())
    );
  }

  constructor(private http: HttpClient,
              private appProfile: AppProfile,
              private authService: AuthService,
              private router: Router) {
  }

  // Example method when fab clicked to add new ruleset
addRuleSet() {
  // this.ruleSetToEdit = { title: '', description: '' };
  this.selectedRuleType = 'Health';
  this.showAddRuleSetModal = true;
}

// Unified save handler
onSave() {
  if (this.showEditRuleSetModal) {
    // update existing ruleset logic
  } else {
    // create new ruleset logic using ruleSetToEdit
  }
  this.closeAddRuleSetModal();
}

closeAddRuleSetModal() {
  this.showAddRuleSetModal = false;
  this.showEditRuleSetModal = false;
  this.ruleSetToEdit = null;
}

  ngOnInit() {
    this.fetchPlanDefinitionRules();
  }

  private getCommonHeaders(): HttpHeaders {
    const accessToken = this.authService.accessToken;
    return new HttpHeaders({
      'X-tenant-Id': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'Content-Type': 'application/json',
      'org': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'Authorization': `Bearer ${accessToken}`,
    });
  }

  fetchPlanDefinitionRules() {
    const headers = this.getCommonHeaders().set('api-version', '2.0.0');
    const orgId = this.getCommonHeaders().get('org');
    this.http.get<any>(`${this.appProfile.ampmUs}/pes/fhir/${orgId}/PlanDefinition`, { headers }).subscribe(res => {
      if (res && res.entry) {
        this.planDefinitionRules = res.entry.flatMap((e: any) => {
          const resource = e.resource;
          if (!resource.action) return [];
          return resource.action.map((action: any) => ({
            title: resource.title || resource.name || 'Untitled Rule',
            enabled: true,
            when: action.textEquivalent || '',
            then: 'Add a task to follow up with the patient. With a priority of Medium',
            priority: 'Medium'
          }));
        });
      }
    });
  }

  // addRuleSet() {
  //   this.ruleSetToEdit = {
  //     title: '',
  //     description: '',
  //     status: 'active',
  //     rules: []
  //   };
  //   this.availableItems = ['Item 1', 'Item 2', 'Item 3']; // Replace with real data if needed
  //   this.selectedItems = [];
  //   this.availableFilter = '';
  //   this.selectedFilter = '';
  //   alert('DEBUG: addRuleSet() called!');
  //   console.log('addRuleSet called');
  //   this.showAddRuleSetModal = true;
  //   this.cdr.detectChanges();
  //   console.log('showAddRuleSetModal:', this.showAddRuleSetModal, 'ruleSetToEdit:', this.ruleSetToEdit);
  // }

  // closeAddRuleSetModal() {
  //   this.showAddRuleSetModal = false;
  // }

  saveNewRuleSet() {
    // Implement save logic here
    this.showAddRuleSetModal = false;
  }

  // Dual list logic (stubbed for now)
  selectAvailableItem(item: string) {
    if (!this.selectedItems.includes(item)) {
      this.selectedItems.push(item);
    }
  }
  selectSelectedItem(item: string) {
    this.selectedItems = this.selectedItems.filter(i => i !== item);
  }
  moveToSelected() {
    const toMove = this.filteredAvailableItems[0];
    if (toMove) this.selectAvailableItem(toMove);
  }
  moveToAvailable() {
    const toMove = this.filteredSelectedItems[0];
    if (toMove) this.selectSelectedItem(toMove);
  }
  selectRuleSet(event: any) {
    this.selectedRuleSetId = event.target.value;
    this.selectedRuleSet = this.ruleSets.find(set => set.id === this.selectedRuleSetId);
  }

  setRuleType(type: string) {
    this.selectedRuleType = type;
    // Optionally filter rules by type here
  }

  toggleRule(rule: Rule) {
    rule.enabled = !rule.enabled;
  }

  editRule(rule: Rule) {
    this.ruleToEdit = { ...rule };
    this.showEditRuleModal = true;
  }

  nextPage() {
    if (this.page < this.totalPages) this.page++;
  }

  prevPage() {
    if (this.page > 1) this.page--;
  }

}
